<nz-skeleton [nzActive]="true" [nzLoading]="loading" [nzParagraph]="{ rows: 6 }">
  <nz-table [nzData]="events" [nzBordered]="false" [nzSize]="'small'" [nzShowPagination]="false">
    <thead>
      <tr>
        <th nzWidth="80px" [nzAlign]="'center'">ID</th>
        <th>Event</th>
        <th nzWidth="150px">Event Type</th>
        <th [nzAlign]="'left'">Event Date</th>
        <th nzWidth="120px" [nzAlign]="'left'">Status</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let e of events">
        <td [nzAlign]="'center'">
          <nz-tag>{{ formatIdToFourDigits(e?.id) }}</nz-tag>
        </td>
        <td>
          <div class="event-image-container" style="display:flex; gap:12px; align-items:center;">
            <img nz-image width="160" height="80" style="border-radius:8px;"
                 [nzSrc]="getBase64Image(e?.photo) || defaultEventImage" alt="event-image-{{e?.id}}" />
            <div class="event-title-container">
              <h3 nz-tooltip [nzTooltipTitle]="e?.event_name" nzTooltipPlacement="top" style="margin:0;">
                <a [href]="'/app/events/' + e?.id" target="_blank"><strong>{{ e?.event_name }}</strong></a>
              </h3>
              <p style="margin:4px 0 0 0; color:#666;">
                {{ e?.city_name }}<span *ngIf="e?.state">,</span> {{ e?.state }}<span *ngIf="e?.country">,</span> {{ e?.country }}
              </p>
            </div>
          </div>
        </td>
        <td>{{ e?.event_type_details?.name }}</td>
        <td nzAlign="left">
          <nz-tag [nzColor]="'processing'" [nzBordered]="true" *ngIf="e?.start_datetime">
            <nz-icon nzType="clock-circle" /> {{ e?.start_datetime | date:'medium' }}
          </nz-tag>
        </td>
        <td [nzAlign]="'left'">
          <nz-tag [nzColor]="getEventStatusColor(e?.status_name)">{{ e?.status_name }}</nz-tag>
        </td>
      </tr>
    </tbody>
  </nz-table>
</nz-skeleton>
